import { attr, fk, oneToOne } from 'redux-orm';
import {
    OBJECT_TYPE_GENERAL_ADMISSION,
    GENERAL_ADMISSION_PURCHASE_STATUS_FREE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import BaseModel from './BaseModel';
import singleLabel from '%paysera_seat_selection/js/seatSelection/redux/model/defaults/singleLabel';

class GeneralAdmission extends BaseModel {
    static modelName = 'GeneralAdmission';

    static fields = {
        ...BaseModel.fields,
        objectType: attr({ getDefault: () => OBJECT_TYPE_GENERAL_ADMISSION }),
        seatsTotal: attr({ getDefault: () => 0 }),
        seatsUsed: attr({ getDefault: () => 0 }),
        label: attr({ getDefault: () => singleLabel }),
        hall: fk('Hall'),
        ticketType: fk('TicketType'),
        reservation: fk('Reservation'),
        forCashier: attr({ getDefault: () => false }),
        enabled: attr({ getDefault: () => true }),
        configuration: oneToOne('Configuration'),
        purchaseStatus: attr({ getDefault: () => GENERAL_ADMISSION_PURCHASE_STATUS_FREE }),
    };
}

export default GeneralAdmission;
